import { MockCard, MockButton } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function KpMode() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Режим КП</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Режим КП (коммерческое предложение) включается на странице заявки. Позволяет выбрать цены
          из разных матриц, применить наценки и сформировать Excel-файл для клиента.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как включить:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Откройте страницу заявки</li>
            <li>
              В панели действий нажмите <MockButton variant="secondary">Режим КП</MockButton>
            </li>
            <li>Таблица позиций переключится — появятся ячейки для выбора цен</li>
            <li>Кликните на цену в нужной матрице — выбор подсветится</li>
            <li>
              Кнопка <MockButton variant="secondary">По лучшим ценам</MockButton> подберёт минимум в
              рублях по всем позициям;{' '}
              <MockButton variant="secondary">Выбрать все позиции</MockButton> возьмёт даже те, по
              которым нет цен (с ценой 0)
            </li>
            <li>Нажмите «Скачать КП» → Excel сгенерируется и снапшот сохранится на сервер</li>
          </ol>
          <p className="mt-2">
            Для каждой матрицы есть индивидуальная наценка, можно также задать персональную наценку
            на конкретную позицию (блок «Наценки на позиции»).
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function KpPrices() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Выбор цен</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Для каждой позиции закупщики могут предложить цены из разных источников (матриц). Менеджер
          выбирает лучшую цену для КП клиенту.
        </p>
      </div>
      <MockTable
        caption="5 матриц поставщиков"
        columns={[{ header: 'Матрица' }, { header: 'Описание' }, { header: 'Кто заполняет' }]}
        rows={[
          [
            <MockBadge color="green">Склад</MockBadge>,
            'Есть на складе, быстрая отгрузка',
            'Менеджер',
          ],
          [
            <MockBadge color="blue">Китай</MockBadge>,
            'Китайские поставщики (3-6 недель)',
            'Закупщик',
          ],
          [<MockBadge color="purple">РФ</MockBadge>, 'Российские дистрибьюторы', 'Менеджер'],
          [
            <MockBadge color="orange">Производители</MockBadge>,
            'Напрямую от производителя',
            'Закупщик',
          ],
          [<MockBadge color="gray">Стоки</MockBadge>, 'Остатки, разовые предложения', 'Менеджер'],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <p>
            В режиме КП каждая матрица отображается как радиокнопка. Выбранная цена подсвечивается и
            используется для расчёта итоговой суммы КП.
          </p>
          <p>
            Кнопка «По лучшим ценам» автоматически берёт минимальную цену в рублях по каждой
            позиции. <span className="font-medium">Цена 0 лучшей не считается</span> — это
            квота-заготовка или пометка «Позиция отсутствует», реальной цены в ней нет, в автоподбор
            и в КП она не попадает.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function KpMarkup() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Наценки</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Каждая матрица имеет свой коэффициент наценки. Наценка применяется автоматически при
          выборе цены в режиме КП.
        </p>
      </div>
      <MockTable
        caption="Пример коэффициентов наценки"
        columns={[{ header: 'Матрица' }, { header: 'Коэффициент' }, { header: 'Пример: цена $10' }]}
        rows={[
          ['Склад', '×1.35', '$13.50 → в ₽ по курсу'],
          ['Китай', '×1.40', '$14.00 → в ₽ по курсу'],
          ['РФ', '×1.30', '$13.00 → в ₽ по курсу'],
          ['Производители', '×1.45', '$14.50 → в ₽ по курсу'],
          ['Стоки', '×1.25', '$12.50 → в ₽ по курсу'],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Коэффициенты настраиваются ADMIN'ом на странице «Курс валют» → раздел «Константы наценки».
          Пересчёт в рубли происходит по текущему курсу USD/EUR/CNY.
        </div>
      </MockCard>
    </div>
  )
}

export function KpQuotesSelection() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Страница выбора квот
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Отдельный экран для массовой работы с квотами по заявке —{' '}
          <span className="font-mono text-xs">/requests/:id/quotes-selection</span>. Удобен когда в
          заявке много позиций и нужно быстро отобрать котировки для КП.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Что доступно:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Сводка по позициям — сколько квот, диапазон цен, выбор</li>
            <li>Фильтры — по матрице, поставщику, наличию цены</li>
            <li>Свёртывание секций — большие заявки удобнее листать по группам</li>
            <li>
              Кнопка <MockButton variant="secondary">По лучшим ценам</MockButton> — автоподбор
              минимальных цен по всем позициям одним нажатием
            </li>
            <li>Выбор синхронизирован с режимом КП на странице заявки</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function KpPreview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Предпросмотр КП
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В режиме КП рядом с кнопкой «Скачать КП» есть «Предпросмотр КП» — открывает модальное окно
          с финальными ценами в рублях, теми же что попадут в Excel и в снапшот на сервере.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Зачем нужно:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Проверить итоговые цены до отправки клиенту — без скачивания файла</li>
            <li>Подкрутить наценки и сразу увидеть результат — пересчёт live</li>
            <li>Понять общую сумму КП и разрез по позициям одним взглядом</li>
            <li>Из модального окна можно сразу нажать «Скачать КП» — двойной шаг не нужен</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function KpExport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Генерация Excel
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          После выбора цен нажмите «Скачать КП» — система сгенерирует Excel-файл и сохранит снапшот
          (снимок выбранных цен, курсов и наценок). Заявка автоматически перейдёт в статус
          QUOTATION_CREATED.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Что содержит Excel-файл КП:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>Партномер и бренд каждой позиции</li>
            <li>Количество</li>
            <li>Цена за единицу в ₽ (с наценкой)</li>
            <li>Сумма по позиции</li>
            <li>Итоговая сумма КП</li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">Снапшот:</div>
          <p>
            Каждое сформированное КП сохраняется как снапшот — можно вернуться и посмотреть, какие
            цены, курсы и наценки были использованы. История КП отображается в панели заявки. КП
            формируется в формате Excel (не PDF).
          </p>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">
            Закрытие позиции в заказ:
          </div>
          <p>
            Когда позиция закрывается в заказ, её цена фиксируется — дальнейшие изменения квот и
            курсов на уже заказанную позицию не влияют. Зафиксированные цены используются в отчётах
            «Сумма в заказ» в разделе «Планирование».
          </p>
        </div>
      </MockCard>
    </div>
  )
}
